export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0006s_0000_Black-&-White-26.81f5e8fb.png";